import { Radio } from 'antd'
import './RadioButtonCommon.scss'
import PropTypes from 'prop-types'
import './RadioButtonCommon.scss'

const RadioButtonCommon = ({
	options,
	onChange,
	value,
	optionType = 'default',
	label,
}) => {
	return (
		<div className="radio-button-common">
			{label && <div className="label u-title">{label}</div>}
			<Radio.Group
				options={options}
				onChange={onChange}
				value={value}
				optionType={optionType}
			/>
		</div>
	)
}

RadioButtonCommon.propTypes = {
	options: PropTypes.any,
	onChange: PropTypes.func,
	value: PropTypes.any,
	optionType: PropTypes.string,
	label: PropTypes.any,
}

export default RadioButtonCommon
